export default "__VITE_ASSET__B1oUZUin__ 100w";